<template>
  <div style="height: 100vh;background-color: #ffffff;">
    <div
      class="navbar nav-main w-100"
      style="background-color:#23409A;color:white"
    >
      <h3 class="w-100 text-center my-3">ยืนยันตัวตน</h3>
    </div>
    <div class="mb-2 flex-all-center session-with-nav">
      <div>
        <v-img
          class="my-0 radius-circle"
          style="width:170px;height:auto"
          src="@/assets/logo_long.png"
        ></v-img>
      </div>
    </div>
    <div class="pa-6">
      <ValidationObserver ref="observer">
        <div class="mb-4" style="color: #817F7F;">
          กรุณาระบุรายละเอียดของผู้ทำสัญญา
        </div>
        <ValidationProvider
          rules="required|thai_idcard"
          name="บัตรประชาชน"
          v-slot="{ errors }"
        >
          <v-text-field
            v-mask="'#-####-#####-##-#'"
            :error-messages="errors"
            class="mt-4"
            dense
            type="tel"
            pattern="\d*"
            v-model="data.idCard"
            autocomplete="off"
            label="เลขบัตรประชาชน"
            outlined
          ></v-text-field>
          <!-- <v-text-field-simplemask
            class="mt-0"
            v-model="data.idcard"
            label="เลขบัตรประชาชน"
            :error-messages="errors"
            :properties="{
              type: 'tel',
              prefix: '',
              suffix: '',
              dense: true,
              readonly: false,
              disabled: false,
              outlined: true,
              clearable: false,
              placeholder: '',
            }"
            :options="{
              type: 'tel',
              inputMask: '#-####-#####-##-#',
              outputMask: '#############',
              empty: null,
              applyAfter: false,
              alphanumeric: true,
              lowerCase: false,
            }"
            v-bind:focus="focus"
            v-on:focus="focus = false"
          /> -->
        </ValidationProvider>
        <!-- <div
          v-if="submited && input.idcard.length !== 13"
          class="fs-13"
          style="color:red;margin-top:-25px"
        >
          กรอกเลขบัตรประชาชนไม่ครบถ้วน
        </div> -->
        <div class="mt-3" style="color: #817F7F;">กรุณาระบุวันเกิด</div>
        <v-layout row wrap class="mt-5">
          <v-flex xs3>
            <ValidationProvider
              rules="required|day"
              name="วันเกิด"
              v-slot="{ errors }"
            >
              <v-text-field
                v-mask="'##'"
                :error-messages="errors"
                dense
                type="number"
                pattern="\d*"
                v-model="data.dobDay"
                autocomplete="off"
                label="วัน"
                min="1"
                max="31"
                outlined
              ></v-text-field>
            </ValidationProvider>
          </v-flex>
          <v-flex xs5 class="pl-0">
            <ValidationProvider
              rules="required|month"
              name="เดือน"
              v-slot="{ errors }"
            >
              <v-text-field
                v-mask="'##'"
                :error-messages="errors"
                dense
                type="number"
                pattern="\d*"
                v-model="data.dobMonth"
                autocomplete="off"
                label="เดือน เช่น 08"
                min="1"
                max="12"
                outlined
              ></v-text-field>
            </ValidationProvider>
          </v-flex>
          <v-flex xs4 class="pl-0">
            <ValidationProvider
              rules="required|year"
              name="ปี"
              v-slot="{ errors }"
            >
              <v-text-field
                v-mask="'####'"
                :error-messages="errors"
                dense
                type="number"
                pattern="\d*"
                v-model="data.dobYear"
                autocomplete="off"
                label="ปี พ.ศ."
                max="4"
                outlined
              ></v-text-field>
            </ValidationProvider>
          </v-flex>
        </v-layout>
        <!-- <div v-if="submited && !input.date" class="fs-13" style="color:red;">
          วันเดือนปีเกิดรูปแบบไม่ถูกต้อง
        </div>
        <div v-if="submited && !input.date" class="fs-13" style="color:red;">
          **ตัวอย่าง 01 06 2564
        </div> -->
        <ValidationProvider
          rules="required|nextcardId"
          name="เลขบัตร Next Card"
          v-slot="{ errors }"
        >
          <v-text-field
            v-mask="'#################'"
            :error-messages="errors"
            class="mt-4"
            dense
            type="number"
            pattern="\d*"
            v-model="data.nextCard"
            autocomplete="off"
            label="เลขบัตร Next Card"
            outlined
          ></v-text-field>
        </ValidationProvider>
        <div class="text-blue mb-3" @click="whatNextPop = true">
          <span class="fs-14" style="text-decoration: underline;"
            >Next Card คืออะไร</span
          >&nbsp;&nbsp;
          <v-btn color="#23409a" x-small outlined icon
            ><span class="fs-16 p-1">?</span></v-btn
          >
        </div>
        <div style="color: #817F7F;" class="mb-4">
          กรุณาถ่ายภาพเพื่อยืนยันตัวตน
        </div>
        <ValidationProvider
          rules="required"
          name="รูปถ่ายใบหน้าตนเอง"
          v-slot="{ errors }"
        >
          <UploadFile
            :errors="errors"
            :key="keyupload"
            :label="'รูปถ่ายใบหน้าตนเอง'"
            :showpreview="true"
            :opencamera="true"
            :descriptionImage="imgDisp[0]"
            v-model="data.faceImage"
            :max="1"
            class="mb-8"
          >
          </UploadFile>
        </ValidationProvider>

        <ValidationProvider
          rules="required"
          name="รูปถ่ายใบหน้าคู่บัตรประชาชน"
          v-slot="{ errors }"
        >
          <UploadFile
            :errors="errors"
            :key="keyupload"
            :label="'รูปถ่ายใบหน้าคู่บัตรประชาชน'"
            :descriptionImage="imgDisp[1]"
            :showpreview="true"
            :opencamera="true"
            v-model="data.idcardImage"
            :max="1"
          >
          </UploadFile>
        </ValidationProvider>
      </ValidationObserver>
      <div class="flex-all-center mt-11">
        <v-btn
          :loading="loading"
          @click="Submit"
          class="col-8 main-btn"
          style="color:white;"
          color="#23409a"
          >ถัดไป</v-btn
        >
      </div>
    </div>
    <ShowSuccessDialog v-model="showAlert"
      >ระบบได้ทำการแก้ไขที่อยู่ ให้ท่านเรียบร้อยแล้ว</ShowSuccessDialog
    >
    <v-dialog
      v-model="whatNextPop"
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card class="py-2 px-5">
        <div class="text-right">
          <v-btn icon @click="whatNextPop = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="my-3 col-12 flex-all-center">
          <v-img
            class="my-5 radius-circle"
            style="width:80%;height:auto"
            src="@/assets/ex_card.jpg"
          ></v-img>
        </div>
        <div class="text-center">
          บัตร Next Card คือบัตรที่ลูกค้าจะได้รับจากพนักงานเน็คซ์
          พร้อมตอนรับมอบรถฯ โดยด้าน หน้าบัตรจะมีเลข 17 หลัก เพื่อใช้ชำระเงิน และ
          หลังบัตรจะมีบาร์โค้ดพร้อมรายละเอียด ค่างวดรถ
        </div>
        <div style="text-align: center;" class="mt-2">
          <v-btn color="#23409a" @click="askmore">
            <span class="text-white">สอบถามเพิ่มเติม</span>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { extend } from "vee-validate";
import UploadFile from "@/components/UploadFile";
import ShowSuccessDialog from "./SuccessDialog.vue";
import moment from "moment";
import api from "@/api";
import config from "@/config";

extend("thai_idcard", {
  message: "รูปแบบเลขบัตรประชาชนไม่ถูกต้อง",
  validate: (value) => {
    let result = value.length == 17;
    return result;
  },
});

extend("nextcardId", {
  message: "รูปแบบเลขบัตร Next Card ไม่ถูกต้อง",
  validate: (value) => {
    let result = value.length == 17;
    return result;
  },
});

extend("month", {
  message: "เดือนต้องมีค่า 01-12",
  validate: (value) => {
    let result = value < 13 && value > 0;
    return result;
  },
});

extend("day", {
  message: "วันที่ต้องไม่เกิน 31",
  validate: (value) => {
    let result = value < 32 && value > 0;
    return result;
  },
});

extend("year", {
  message: "ปีไม่ถูกต้อง",
  validate: (value) => {
    let result = value.length == 4;
    return result;
  },
});

export default {
  components: {
    UploadFile,
    ShowSuccessDialog,
  },
  data() {
    return {
      dRules: [(v) => (!!v && v < 32 && v > 0) || "วันที่ต้องไม่เกิน 31"],
      mRules: [(v) => (!!v && v < 13 && v > 0) || "เดือนต้องมีค่า 01-12"],
      yRules: [(v) => !!v || "ปี พ.ศ."],
      max13: [
        (v) => !!v || "กรุณาระบุเลขบัตรประชาชน",
        (v) => (v && v.length <= 17) || "เลขบัตรประชาชนไม่ถูกต้อง",
      ],
      input: {
        idcard: "",
        date: null,
      },
      inputDate: {
        day: null,
        month: null,
        year: null,
      },
      keyupload: 1,
      focus: false,
      submited: false,
      loading: false,
      imgDisp: [
        require("@/assets/selfies.png"),
        require("@/assets/idcard.png"),
      ],
      showAlert: false,
      whatNextPop: false,
    };
  },
  // watch: {
  //   inputDate: {
  //     immediate: true,
  //     deep: true,
  //     handler(inputDate) {
  //       let d = this.data.dobDay ? parseInt(this.data.dobDay) : 0;
  //       let m = this.data.dobMonth ? parseInt(this.data.dobMonth) : 0;
  //       let y = this.data.dobYear ? parseInt(this.data.dobYear) : 0;
  //       if (d && m && y) {
  //         this.input.date = moment(
  //           new Date(
  //             parseInt(this.data.dobYear) - 543,
  //             parseInt(this.data.dobMonth) - 1,
  //             this.data.dobDay
  //           )
  //         ).format("YYYY-MM-DD");
  //       } else {
  //         this.input.date = null;
  //       }
  //     },
  //   },
  // },
  methods: {
    async Submit() {
      this.submited = true;
      this.loading = true;

      let valid = await this.$refs.observer.validate();
      if (valid) {
        // *TODO Something like that
        // faceImage, idcardImage as Array, To use get index 0 only
        // idcard -> replace "-" with "" first use
        this.input.date = moment(
          new Date(
            parseInt(this.data.dobYear) - 543,
            parseInt(this.data.dobMonth) - 1,
            this.data.dobDay
          )
        ).format("YYYY-MM-DD");

        // check user
        let body = {
          pageid: config.pageid,
          idCard: this.data.idCard.replaceAll("-", ""),
          dob: moment(this.input.date).format("DD/MM/YYYY"),
          nextCard: this.data.nextCard,
        };
        let validataCustomer = await api.validataCustomer(body);
        this.loading = false;
        // console.log("validataCustomer : ", validataCustomer);
        if (validataCustomer) {
          // this.showAlert = true;
          let data = {
            idcard: this.data.idCard,
            dob: moment(this.input.date).format("DD/MM/YYYY"),
            nextcard: this.data.nextCard,
            faceImage: this.data.faceImage,
            idcardImage: this.data.idcardImage,
          };
          let formatData = JSON.parse(JSON.stringify(data));
          formatData.idcard = formatData.idcard.replace(/-/g, "");
          formatData.faceImage = formatData.faceImage[0];
          formatData.idcardImage = formatData.idcardImage[0];
          this.$store.commit("setFormatAuthorizeData", formatData);
          this.$emit("auth:succeed");
        } else {
          this.$swal.fire({
            type: "error",
            text: "ไม่พบข้อมูลในระบบ",
          });
        }
      } else {
        this.loading = false;
      }
    },
    async askmore() {
      await this.$store.dispatch(
        "sendMessage",
        "สอบถามเพิ่มเติมเรื่อง Next Card"
      );
      if (this.$liff.isInClient()) {
        this.$liff.closeWindow();
      } else {
        this.$store.dispatch("messengerClose");
      }
    },
  },
  computed: {
    data() {
      return this.$store.state.authorizeData;
    },
  },
};
</script>
